import { styled, Box } from "@mui/material";

export const PDFWindowWrapper = styled(Box)({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '50px',
    padding: "50px 0",
});